var Xt = Object.defineProperty;
var Qt = (e, t, n) => t in e ? Xt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var N = (e, t, n) => Qt(e, typeof t != "symbol" ? t + "" : t, n);
import { Time as ie, definedNotNull as B, HttpFailure as en, responseDecoder as tn, ErrorCodes as nn, authErr as X, toObject as ze } from "@df/common";
import { Buffer as rn } from "buffer";
import { storedUserToken as on, renewAuthorizationToken as sn, natsUserCredentialsDecoder as un } from "@df/auth";
const cn = {
  withStackTrace: !1
}, pt = (e, t, n = cn) => {
  const r = t.isOk() ? { type: "Ok", value: t.value } : { type: "Err", value: t.error }, o = n.withStackTrace ? new Error().stack : void 0;
  return {
    data: r,
    message: e,
    stack: o
  };
};
function W(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(s) {
      s(i);
    });
  }
  return new (n || (n = Promise))(function(i, s) {
    function u(l) {
      try {
        a(r.next(l));
      } catch (h) {
        s(h);
      }
    }
    function c(l) {
      try {
        a(r.throw(l));
      } catch (h) {
        s(h);
      }
    }
    function a(l) {
      l.done ? i(l.value) : o(l.value).then(u, c);
    }
    a((r = r.apply(e, [])).next());
  });
}
function Fe(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function J(e) {
  return this instanceof J ? (this.v = e, this) : new J(e);
}
function Je(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), o, i = [];
  return o = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), u("next"), u("throw"), u("return", s), o[Symbol.asyncIterator] = function() {
    return this;
  }, o;
  function s(d) {
    return function(_) {
      return Promise.resolve(_).then(d, h);
    };
  }
  function u(d, _) {
    r[d] && (o[d] = function(w) {
      return new Promise(function(A, k) {
        i.push([d, w, A, k]) > 1 || c(d, w);
      });
    }, _ && (o[d] = _(o[d])));
  }
  function c(d, _) {
    try {
      a(r[d](_));
    } catch (w) {
      p(i[0][3], w);
    }
  }
  function a(d) {
    d.value instanceof J ? Promise.resolve(d.value.v).then(l, h) : p(i[0][2], d);
  }
  function l(d) {
    c("next", d);
  }
  function h(d) {
    c("throw", d);
  }
  function p(d, _) {
    d(_), i.shift(), i.length && c(i[0][0], i[0][1]);
  }
}
function an(e) {
  var t, n;
  return t = {}, r("next"), r("throw", function(o) {
    throw o;
  }), r("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function r(o, i) {
    t[o] = e[o] ? function(s) {
      return (n = !n) ? { value: J(e[o](s)), done: !1 } : i ? i(s) : s;
    } : i;
  }
}
function ln(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof Fe == "function" ? Fe(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(i) {
    n[i] = e[i] && function(s) {
      return new Promise(function(u, c) {
        s = e[i](s), o(u, c, s.done, s.value);
      });
    };
  }
  function o(i, s, u, c) {
    Promise.resolve(c).then(function(a) {
      i({ value: a, done: u });
    }, s);
  }
}
class C {
  constructor(t) {
    this._promise = t;
  }
  static fromSafePromise(t) {
    const n = t.then((r) => new F(r));
    return new C(n);
  }
  static fromPromise(t, n) {
    const r = t.then((o) => new F(o)).catch((o) => new M(n(o)));
    return new C(r);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static fromThrowable(t, n) {
    return (...r) => new C(W(this, void 0, void 0, function* () {
      try {
        return new F(yield t(...r));
      } catch (o) {
        return new M(n ? n(o) : o);
      }
    }));
  }
  static combine(t) {
    return fn(t);
  }
  static combineWithAllErrors(t) {
    return hn(t);
  }
  map(t) {
    return new C(this._promise.then((n) => W(this, void 0, void 0, function* () {
      return n.isErr() ? new M(n.error) : new F(yield t(n.value));
    })));
  }
  andThrough(t) {
    return new C(this._promise.then((n) => W(this, void 0, void 0, function* () {
      if (n.isErr())
        return new M(n.error);
      const r = yield t(n.value);
      return r.isErr() ? new M(r.error) : new F(n.value);
    })));
  }
  andTee(t) {
    return new C(this._promise.then((n) => W(this, void 0, void 0, function* () {
      if (n.isErr())
        return new M(n.error);
      try {
        yield t(n.value);
      } catch {
      }
      return new F(n.value);
    })));
  }
  orTee(t) {
    return new C(this._promise.then((n) => W(this, void 0, void 0, function* () {
      if (n.isOk())
        return new F(n.value);
      try {
        yield t(n.error);
      } catch {
      }
      return new M(n.error);
    })));
  }
  mapErr(t) {
    return new C(this._promise.then((n) => W(this, void 0, void 0, function* () {
      return n.isOk() ? new F(n.value) : new M(yield t(n.error));
    })));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThen(t) {
    return new C(this._promise.then((n) => {
      if (n.isErr())
        return new M(n.error);
      const r = t(n.value);
      return r instanceof C ? r._promise : r;
    }));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  orElse(t) {
    return new C(this._promise.then((n) => W(this, void 0, void 0, function* () {
      return n.isErr() ? t(n.error) : new F(n.value);
    })));
  }
  match(t, n) {
    return this._promise.then((r) => r.match(t, n));
  }
  unwrapOr(t) {
    return this._promise.then((n) => n.unwrapOr(t));
  }
  /**
   * @deprecated will be removed in 9.0.0.
   *
   * You can use `safeTry` without this method.
   * @example
   * ```typescript
   * safeTry(async function* () {
   *   const okValue = yield* yourResult
   * })
   * ```
   * Emulates Rust's `?` operator in `safeTry`'s body. See also `safeTry`.
   */
  safeUnwrap() {
    return Je(this, arguments, function* () {
      return yield J(yield J(yield* an(ln(yield J(this._promise.then((n) => n.safeUnwrap()))))));
    });
  }
  // Makes ResultAsync implement PromiseLike<Result>
  then(t, n) {
    return this._promise.then(t, n);
  }
  [Symbol.asyncIterator]() {
    return Je(this, arguments, function* () {
      const n = yield J(this._promise);
      return n.isErr() && (yield yield J(pe(n.error))), yield J(n.value);
    });
  }
}
function pe(e) {
  return new C(Promise.resolve(new M(e)));
}
const mt = (e) => {
  let t = Z([]);
  for (const n of e)
    if (n.isErr()) {
      t = v(n.error);
      break;
    } else
      t.map((r) => r.push(n.value));
  return t;
}, fn = (e) => C.fromSafePromise(Promise.all(e)).andThen(mt), _t = (e) => {
  let t = Z([]);
  for (const n of e)
    n.isErr() && t.isErr() ? t.error.push(n.error) : n.isErr() && t.isOk() ? t = v([n.error]) : n.isOk() && t.isOk() && t.value.push(n.value);
  return t;
}, hn = (e) => C.fromSafePromise(Promise.all(e)).andThen(_t);
var Ze;
(function(e) {
  function t(o, i) {
    return (...s) => {
      try {
        const u = o(...s);
        return Z(u);
      } catch (u) {
        return v(i ? i(u) : u);
      }
    };
  }
  e.fromThrowable = t;
  function n(o) {
    return mt(o);
  }
  e.combine = n;
  function r(o) {
    return _t(o);
  }
  e.combineWithAllErrors = r;
})(Ze || (Ze = {}));
function Z(e) {
  return new F(e);
}
function v(e) {
  return new M(e);
}
class F {
  constructor(t) {
    this.value = t;
  }
  isOk() {
    return !0;
  }
  isErr() {
    return !this.isOk();
  }
  map(t) {
    return Z(t(this.value));
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mapErr(t) {
    return Z(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThen(t) {
    return t(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThrough(t) {
    return t(this.value).map((n) => this.value);
  }
  andTee(t) {
    try {
      t(this.value);
    } catch {
    }
    return Z(this.value);
  }
  orTee(t) {
    return Z(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  orElse(t) {
    return Z(this.value);
  }
  asyncAndThen(t) {
    return t(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  asyncAndThrough(t) {
    return t(this.value).map(() => this.value);
  }
  asyncMap(t) {
    return C.fromSafePromise(t(this.value));
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  unwrapOr(t) {
    return this.value;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  match(t, n) {
    return t(this.value);
  }
  safeUnwrap() {
    const t = this.value;
    return (function* () {
      return t;
    })();
  }
  _unsafeUnwrap(t) {
    return this.value;
  }
  _unsafeUnwrapErr(t) {
    throw pt("Called `_unsafeUnwrapErr` on an Ok", this, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-this-alias, require-yield
  *[Symbol.iterator]() {
    return this.value;
  }
}
class M {
  constructor(t) {
    this.error = t;
  }
  isOk() {
    return !1;
  }
  isErr() {
    return !this.isOk();
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  map(t) {
    return v(this.error);
  }
  mapErr(t) {
    return v(t(this.error));
  }
  andThrough(t) {
    return v(this.error);
  }
  andTee(t) {
    return v(this.error);
  }
  orTee(t) {
    try {
      t(this.error);
    } catch {
    }
    return v(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThen(t) {
    return v(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  orElse(t) {
    return t(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  asyncAndThen(t) {
    return pe(this.error);
  }
  asyncAndThrough(t) {
    return pe(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  asyncMap(t) {
    return pe(this.error);
  }
  unwrapOr(t) {
    return t;
  }
  match(t, n) {
    return n(this.error);
  }
  safeUnwrap() {
    const t = this.error;
    return (function* () {
      throw yield v(t), new Error("Do not use this generator out of `safeTry`");
    })();
  }
  _unsafeUnwrap(t) {
    throw pt("Called `_unsafeUnwrap` on an Err", this, t);
  }
  _unsafeUnwrapErr(t) {
    return this.error;
  }
  *[Symbol.iterator]() {
    const t = this;
    return yield t, t;
  }
}
Ze.fromThrowable;
var Le;
function f(e, t, n) {
  function r(u, c) {
    if (u._zod || Object.defineProperty(u, "_zod", {
      value: {
        def: c,
        constr: s,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), u._zod.traits.has(e))
      return;
    u._zod.traits.add(e), t(u, c);
    const a = s.prototype, l = Object.keys(a);
    for (let h = 0; h < l.length; h++) {
      const p = l[h];
      p in u || (u[p] = a[p].bind(u));
    }
  }
  const o = (n == null ? void 0 : n.Parent) ?? Object;
  class i extends o {
  }
  Object.defineProperty(i, "name", { value: e });
  function s(u) {
    var c;
    const a = n != null && n.Parent ? new i() : this;
    r(a, u), (c = a._zod).deferred ?? (c.deferred = []);
    for (const l of a._zod.deferred)
      l();
    return a;
  }
  return Object.defineProperty(s, "init", { value: r }), Object.defineProperty(s, Symbol.hasInstance, {
    value: (u) => {
      var c, a;
      return n != null && n.Parent && u instanceof n.Parent ? !0 : (a = (c = u == null ? void 0 : u._zod) == null ? void 0 : c.traits) == null ? void 0 : a.has(e);
    }
  }), Object.defineProperty(s, "name", { value: e }), s;
}
class ee extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class vt extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
(Le = globalThis).__zod_globalConfig ?? (Le.__zod_globalConfig = {});
const Pe = globalThis.__zod_globalConfig;
function K(e) {
  return Pe;
}
function gt(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, o]) => t.indexOf(+r) === -1).map(([r, o]) => o);
}
function Oe(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function ge(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Ae(e) {
  return e == null;
}
function Ne(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function dn(e, t) {
  const n = e / t, r = Math.round(n), o = Number.EPSILON * Math.max(Math.abs(n), 1);
  return Math.abs(n - r) < o ? 0 : n - r;
}
const He = /* @__PURE__ */ Symbol("evaluating");
function g(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== He)
        return r === void 0 && (r = He, r = n()), r;
    },
    set(o) {
      Object.defineProperty(e, t, {
        value: o
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Y(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function H(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function Ve(e) {
  return JSON.stringify(e);
}
function pn(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const wt = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function se(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const mn = /* @__PURE__ */ ge(() => {
  var e;
  if (Pe.jitless || typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function ue(e) {
  if (se(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(se(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function yt(e) {
  return ue(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
const _n = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function te(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function V(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function m(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function vn(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const gn = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function wn(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = H(e._zod.def, {
    get shape() {
      const s = {};
      for (const u in t) {
        if (!(u in n.shape))
          throw new Error(`Unrecognized key: "${u}"`);
        t[u] && (s[u] = n.shape[u]);
      }
      return Y(this, "shape", s), s;
    },
    checks: []
  });
  return V(e, i);
}
function yn(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = H(e._zod.def, {
    get shape() {
      const s = { ...e._zod.def.shape };
      for (const u in t) {
        if (!(u in n.shape))
          throw new Error(`Unrecognized key: "${u}"`);
        t[u] && delete s[u];
      }
      return Y(this, "shape", s), s;
    },
    checks: []
  });
  return V(e, i);
}
function bn(e, t) {
  if (!ue(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const s in t)
      if (Object.getOwnPropertyDescriptor(i, s) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const o = H(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return Y(this, "shape", i), i;
    }
  });
  return V(e, o);
}
function zn(e, t) {
  if (!ue(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = H(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Y(this, "shape", r), r;
    }
  });
  return V(e, n);
}
function kn(e, t) {
  var r;
  if ((r = e._zod.def.checks) != null && r.length)
    throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
  const n = H(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Y(this, "shape", o), o;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: t._zod.def.checks ?? []
  });
  return V(e, n);
}
function $n(e, t, n) {
  const o = t._zod.def.checks;
  if (o && o.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const s = H(t._zod.def, {
    get shape() {
      const u = t._zod.def.shape, c = { ...u };
      if (n)
        for (const a in n) {
          if (!(a in u))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (c[a] = e ? new e({
            type: "optional",
            innerType: u[a]
          }) : u[a]);
        }
      else
        for (const a in u)
          c[a] = e ? new e({
            type: "optional",
            innerType: u[a]
          }) : u[a];
      return Y(this, "shape", c), c;
    },
    checks: []
  });
  return V(t, s);
}
function En(e, t, n) {
  const r = H(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, i = { ...o };
      if (n)
        for (const s in n) {
          if (!(s in i))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (i[s] = new e({
            type: "nonoptional",
            innerType: o[s]
          }));
        }
      else
        for (const s in o)
          i[s] = new e({
            type: "nonoptional",
            innerType: o[s]
          });
      return Y(this, "shape", i), i;
    }
  });
  return V(t, r);
}
function Q(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function Zn(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) === !1)
      return !0;
  return !1;
}
function bt(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function le(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function G(e, t, n) {
  var c, a, l, h, p, d;
  const r = e.message ? e.message : le((l = (a = (c = e.inst) == null ? void 0 : c._zod.def) == null ? void 0 : a.error) == null ? void 0 : l.call(a, e)) ?? le((h = t == null ? void 0 : t.error) == null ? void 0 : h.call(t, e)) ?? le((p = n.customError) == null ? void 0 : p.call(n, e)) ?? le((d = n.localeError) == null ? void 0 : d.call(n, e)) ?? "Invalid input", { inst: o, continue: i, input: s, ...u } = e;
  return u.path ?? (u.path = []), u.message = r, t != null && t.reportInput && (u.input = s), u;
}
function Ce(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function ce(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const zt = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Oe, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, kt = f("$ZodError", zt), $t = f("$ZodError", zt, { Parent: Error });
function On(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const o of e.issues)
    o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : r.push(t(o));
  return { formErrors: r, fieldErrors: n };
}
function Tn(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (o, i = []) => {
    for (const s of o.issues)
      if (s.code === "invalid_union" && s.errors.length)
        s.errors.map((u) => r({ issues: u }, [...i, ...s.path]));
      else if (s.code === "invalid_key")
        r({ issues: s.issues }, [...i, ...s.path]);
      else if (s.code === "invalid_element")
        r({ issues: s.issues }, [...i, ...s.path]);
      else {
        const u = [...i, ...s.path];
        if (u.length === 0)
          n._errors.push(t(s));
        else {
          let c = n, a = 0;
          for (; a < u.length; ) {
            const l = u[a];
            a === u.length - 1 ? (c[l] = c[l] || { _errors: [] }, c[l]._errors.push(t(s))) : c[l] = c[l] || { _errors: [] }, c = c[l], a++;
          }
        }
      }
  };
  return r(e), n;
}
const je = (e) => (t, n, r, o) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, s = t._zod.run({ value: n, issues: [] }, i);
  if (s instanceof Promise)
    throw new ee();
  if (s.issues.length) {
    const u = new ((o == null ? void 0 : o.Err) ?? e)(s.issues.map((c) => G(c, i, K())));
    throw wt(u, o == null ? void 0 : o.callee), u;
  }
  return s.value;
}, Re = (e) => async (t, n, r, o) => {
  const i = r ? { ...r, async: !0 } : { async: !0 };
  let s = t._zod.run({ value: n, issues: [] }, i);
  if (s instanceof Promise && (s = await s), s.issues.length) {
    const u = new ((o == null ? void 0 : o.Err) ?? e)(s.issues.map((c) => G(c, i, K())));
    throw wt(u, o == null ? void 0 : o.callee), u;
  }
  return s.value;
}, we = (e) => (t, n, r) => {
  const o = r ? { ...r, async: !1 } : { async: !1 }, i = t._zod.run({ value: n, issues: [] }, o);
  if (i instanceof Promise)
    throw new ee();
  return i.issues.length ? {
    success: !1,
    error: new (e ?? kt)(i.issues.map((s) => G(s, o, K())))
  } : { success: !0, data: i.value };
}, Sn = /* @__PURE__ */ we($t), ye = (e) => async (t, n, r) => {
  const o = r ? { ...r, async: !0 } : { async: !0 };
  let i = t._zod.run({ value: n, issues: [] }, o);
  return i instanceof Promise && (i = await i), i.issues.length ? {
    success: !1,
    error: new e(i.issues.map((s) => G(s, o, K())))
  } : { success: !0, data: i.value };
}, In = /* @__PURE__ */ ye($t), Pn = (e) => (t, n, r) => {
  const o = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return je(e)(t, n, o);
}, An = (e) => (t, n, r) => je(e)(t, n, r), Nn = (e) => async (t, n, r) => {
  const o = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return Re(e)(t, n, o);
}, Cn = (e) => async (t, n, r) => Re(e)(t, n, r), jn = (e) => (t, n, r) => {
  const o = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return we(e)(t, n, o);
}, Rn = (e) => (t, n, r) => we(e)(t, n, r), Dn = (e) => async (t, n, r) => {
  const o = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return ye(e)(t, n, o);
}, Un = (e) => async (t, n, r) => ye(e)(t, n, r), Mn = /^[cC][0-9a-z]{6,}$/, xn = /^[0-9a-z]+$/, Fn = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Jn = /^[0-9a-vA-V]{20}$/, Ln = /^[A-Za-z0-9]{27}$/, Hn = /^[a-zA-Z0-9_-]{21}$/, Vn = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Wn = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, We = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Kn = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Gn = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Bn() {
  return new RegExp(Gn, "u");
}
const Yn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, qn = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Xn = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Qn = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, er = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Et = /^[A-Za-z0-9_-]*$/, tr = /^https?$/, nr = /^\+[1-9]\d{6,14}$/, Zt = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", rr = /* @__PURE__ */ new RegExp(`^${Zt}$`);
function Ot(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function or(e) {
  return new RegExp(`^${Ot(e)}$`);
}
function ir(e) {
  const t = Ot({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${Zt}T(?:${r})$`);
}
const sr = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, ur = /^-?\d+$/, cr = /^-?\d+(?:\.\d+)?$/, ar = /^[^A-Z]*$/, lr = /^[^a-z]*$/, D = /* @__PURE__ */ f("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Tt = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, St = /* @__PURE__ */ f("$ZodCheckLessThan", (e, t) => {
  D.init(e, t);
  const n = Tt[typeof t.value];
  e._zod.onattach.push((r) => {
    const o = r._zod.bag, i = (t.inclusive ? o.maximum : o.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < i && (t.inclusive ? o.maximum = t.value : o.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), It = /* @__PURE__ */ f("$ZodCheckGreaterThan", (e, t) => {
  D.init(e, t);
  const n = Tt[typeof t.value];
  e._zod.onattach.push((r) => {
    const o = r._zod.bag, i = (t.inclusive ? o.minimum : o.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > i && (t.inclusive ? o.minimum = t.value : o.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), fr = /* @__PURE__ */ f("$ZodCheckMultipleOf", (e, t) => {
  D.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : dn(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), hr = /* @__PURE__ */ f("$ZodCheckNumberFormat", (e, t) => {
  var s;
  D.init(e, t), t.format = t.format || "float64";
  const n = (s = t.format) == null ? void 0 : s.includes("int"), r = n ? "int" : "number", [o, i] = gn[t.format];
  e._zod.onattach.push((u) => {
    const c = u._zod.bag;
    c.format = t.format, c.minimum = o, c.maximum = i, n && (c.pattern = ur);
  }), e._zod.check = (u) => {
    const c = u.value;
    if (n) {
      if (!Number.isInteger(c)) {
        u.issues.push({
          expected: r,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: c,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(c)) {
        c > 0 ? u.issues.push({
          input: c,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          inclusive: !0,
          continue: !t.abort
        }) : u.issues.push({
          input: c,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    c < o && u.issues.push({
      origin: "number",
      input: c,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), c > i && u.issues.push({
      origin: "number",
      input: c,
      code: "too_big",
      maximum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), dr = /* @__PURE__ */ f("$ZodCheckMaxLength", (e, t) => {
  var n;
  D.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !Ae(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < o && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const o = r.value;
    if (o.length <= t.maximum)
      return;
    const s = Ce(o);
    r.issues.push({
      origin: s,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), pr = /* @__PURE__ */ f("$ZodCheckMinLength", (e, t) => {
  var n;
  D.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !Ae(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > o && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const o = r.value;
    if (o.length >= t.minimum)
      return;
    const s = Ce(o);
    r.issues.push({
      origin: s,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), mr = /* @__PURE__ */ f("$ZodCheckLengthEquals", (e, t) => {
  var n;
  D.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !Ae(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.minimum = t.length, o.maximum = t.length, o.length = t.length;
  }), e._zod.check = (r) => {
    const o = r.value, i = o.length;
    if (i === t.length)
      return;
    const s = Ce(o), u = i > t.length;
    r.issues.push({
      origin: s,
      ...u ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), be = /* @__PURE__ */ f("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  D.init(e, t), e._zod.onattach.push((o) => {
    const i = o._zod.bag;
    i.format = t.format, t.pattern && (i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (o) => {
    t.pattern.lastIndex = 0, !t.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: o.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), _r = /* @__PURE__ */ f("$ZodCheckRegex", (e, t) => {
  be.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), vr = /* @__PURE__ */ f("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = ar), be.init(e, t);
}), gr = /* @__PURE__ */ f("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = lr), be.init(e, t);
}), wr = /* @__PURE__ */ f("$ZodCheckIncludes", (e, t) => {
  D.init(e, t);
  const n = te(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((o) => {
    const i = o._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), e._zod.check = (o) => {
    o.value.includes(t.includes, t.position) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), yr = /* @__PURE__ */ f("$ZodCheckStartsWith", (e, t) => {
  D.init(e, t);
  const n = new RegExp(`^${te(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), br = /* @__PURE__ */ f("$ZodCheckEndsWith", (e, t) => {
  D.init(e, t);
  const n = new RegExp(`.*${te(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), zr = /* @__PURE__ */ f("$ZodCheckOverwrite", (e, t) => {
  D.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class kr {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((s) => s), o = Math.min(...r.map((s) => s.length - s.trimStart().length)), i = r.map((s) => s.slice(o)).map((s) => " ".repeat(this.indent * 2) + s);
    for (const s of i)
      this.content.push(s);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, o = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, o.join(`
`));
  }
}
const $r = {
  major: 4,
  minor: 4,
  patch: 3
}, $ = /* @__PURE__ */ f("$ZodType", (e, t) => {
  var o;
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = $r;
  const r = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && r.unshift(e);
  for (const i of r)
    for (const s of i._zod.onattach)
      s(e);
  if (r.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), (o = e._zod.deferred) == null || o.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const i = (u, c, a) => {
      let l = Q(u), h;
      for (const p of c) {
        if (p._zod.def.when) {
          if (Zn(u) || !p._zod.def.when(u))
            continue;
        } else if (l)
          continue;
        const d = u.issues.length, _ = p._zod.check(u);
        if (_ instanceof Promise && (a == null ? void 0 : a.async) === !1)
          throw new ee();
        if (h || _ instanceof Promise)
          h = (h ?? Promise.resolve()).then(async () => {
            await _, u.issues.length !== d && (l || (l = Q(u, d)));
          });
        else {
          if (u.issues.length === d)
            continue;
          l || (l = Q(u, d));
        }
      }
      return h ? h.then(() => u) : u;
    }, s = (u, c, a) => {
      if (Q(u))
        return u.aborted = !0, u;
      const l = i(c, r, a);
      if (l instanceof Promise) {
        if (a.async === !1)
          throw new ee();
        return l.then((h) => e._zod.parse(h, a));
      }
      return e._zod.parse(l, a);
    };
    e._zod.run = (u, c) => {
      if (c.skipChecks)
        return e._zod.parse(u, c);
      if (c.direction === "backward") {
        const l = e._zod.parse({ value: u.value, issues: [] }, { ...c, skipChecks: !0 });
        return l instanceof Promise ? l.then((h) => s(h, u, c)) : s(l, u, c);
      }
      const a = e._zod.parse(u, c);
      if (a instanceof Promise) {
        if (c.async === !1)
          throw new ee();
        return a.then((l) => i(l, r, c));
      }
      return i(a, r, c);
    };
  }
  g(e, "~standard", () => ({
    validate: (i) => {
      var s;
      try {
        const u = Sn(e, i);
        return u.success ? { value: u.data } : { issues: (s = u.error) == null ? void 0 : s.issues };
      } catch {
        return In(e, i).then((c) => {
          var a;
          return c.success ? { value: c.data } : { issues: (a = c.error) == null ? void 0 : a.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), De = /* @__PURE__ */ f("$ZodString", (e, t) => {
  var n;
  $.init(e, t), e._zod.pattern = [...((n = e == null ? void 0 : e._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? sr(e._zod.bag), e._zod.parse = (r, o) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), y = /* @__PURE__ */ f("$ZodStringFormat", (e, t) => {
  be.init(e, t), De.init(e, t);
}), Er = /* @__PURE__ */ f("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = Wn), y.init(e, t);
}), Zr = /* @__PURE__ */ f("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = We(r));
  } else
    t.pattern ?? (t.pattern = We());
  y.init(e, t);
}), Or = /* @__PURE__ */ f("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Kn), y.init(e, t);
}), Tr = /* @__PURE__ */ f("$ZodURL", (e, t) => {
  y.init(e, t), e._zod.check = (n) => {
    var r;
    try {
      const o = n.value.trim();
      if (!t.normalize && ((r = t.protocol) == null ? void 0 : r.source) === tr.source && !/^https?:\/\//i.test(o)) {
        n.issues.push({
          code: "invalid_format",
          format: "url",
          note: "Invalid URL format",
          input: n.value,
          inst: e,
          continue: !t.abort
        });
        return;
      }
      const i = new URL(o);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = o;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Sr = /* @__PURE__ */ f("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Bn()), y.init(e, t);
}), Ir = /* @__PURE__ */ f("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Hn), y.init(e, t);
}), Pr = /* @__PURE__ */ f("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Mn), y.init(e, t);
}), Ar = /* @__PURE__ */ f("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = xn), y.init(e, t);
}), Nr = /* @__PURE__ */ f("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = Fn), y.init(e, t);
}), Cr = /* @__PURE__ */ f("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = Jn), y.init(e, t);
}), jr = /* @__PURE__ */ f("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Ln), y.init(e, t);
}), Rr = /* @__PURE__ */ f("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = ir(t)), y.init(e, t);
}), Dr = /* @__PURE__ */ f("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = rr), y.init(e, t);
}), Ur = /* @__PURE__ */ f("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = or(t)), y.init(e, t);
}), Mr = /* @__PURE__ */ f("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Vn), y.init(e, t);
}), xr = /* @__PURE__ */ f("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Yn), y.init(e, t), e._zod.bag.format = "ipv4";
}), Fr = /* @__PURE__ */ f("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = qn), y.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Jr = /* @__PURE__ */ f("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Xn), y.init(e, t);
}), Lr = /* @__PURE__ */ f("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Qn), y.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [o, i] = r;
      if (!i)
        throw new Error();
      const s = Number(i);
      if (`${s}` !== i)
        throw new Error();
      if (s < 0 || s > 128)
        throw new Error();
      new URL(`http://[${o}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Pt(e) {
  if (e === "")
    return !0;
  if (/\s/.test(e) || e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Hr = /* @__PURE__ */ f("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = er), y.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    Pt(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function Vr(e) {
  if (!Et.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Pt(n);
}
const Wr = /* @__PURE__ */ f("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = Et), y.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    Vr(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Kr = /* @__PURE__ */ f("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = nr), y.init(e, t);
});
function Gr(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const o = JSON.parse(atob(r));
    return !("typ" in o && (o == null ? void 0 : o.typ) !== "JWT" || !o.alg || t && (!("alg" in o) || o.alg !== t));
  } catch {
    return !1;
  }
}
const Br = /* @__PURE__ */ f("$ZodJWT", (e, t) => {
  y.init(e, t), e._zod.check = (n) => {
    Gr(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), At = /* @__PURE__ */ f("$ZodNumber", (e, t) => {
  $.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? cr, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const o = n.value;
    if (typeof o == "number" && !Number.isNaN(o) && Number.isFinite(o))
      return n;
    const i = typeof o == "number" ? Number.isNaN(o) ? "NaN" : Number.isFinite(o) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: o,
      inst: e,
      ...i ? { received: i } : {}
    }), n;
  };
}), Yr = /* @__PURE__ */ f("$ZodNumberFormat", (e, t) => {
  hr.init(e, t), At.init(e, t);
}), qr = /* @__PURE__ */ f("$ZodUnknown", (e, t) => {
  $.init(e, t), e._zod.parse = (n) => n;
}), Xr = /* @__PURE__ */ f("$ZodNever", (e, t) => {
  $.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function Ke(e, t, n) {
  e.issues.length && t.issues.push(...bt(n, e.issues)), t.value[n] = e.value;
}
const Qr = /* @__PURE__ */ f("$ZodArray", (e, t) => {
  $.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    n.value = Array(o.length);
    const i = [];
    for (let s = 0; s < o.length; s++) {
      const u = o[s], c = t.element._zod.run({
        value: u,
        issues: []
      }, r);
      c instanceof Promise ? i.push(c.then((a) => Ke(a, n, s))) : Ke(c, n, s);
    }
    return i.length ? Promise.all(i).then(() => n) : n;
  };
});
function me(e, t, n, r, o, i) {
  const s = n in r;
  if (e.issues.length) {
    if (o && i && !s)
      return;
    t.issues.push(...bt(n, e.issues));
  }
  if (!s && !o) {
    e.issues.length || t.issues.push({
      code: "invalid_type",
      expected: "nonoptional",
      input: void 0,
      path: [n]
    });
    return;
  }
  e.value === void 0 ? s && (t.value[n] = void 0) : t.value[n] = e.value;
}
function Nt(e) {
  var r, o, i, s;
  const t = Object.keys(e.shape);
  for (const u of t)
    if (!((s = (i = (o = (r = e.shape) == null ? void 0 : r[u]) == null ? void 0 : o._zod) == null ? void 0 : i.traits) != null && s.has("$ZodType")))
      throw new Error(`Invalid element at key "${u}": expected a Zod schema`);
  const n = vn(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function Ct(e, t, n, r, o, i) {
  const s = [], u = o.keySet, c = o.catchall._zod, a = c.def.type, l = c.optin === "optional", h = c.optout === "optional";
  for (const p in t) {
    if (p === "__proto__" || u.has(p))
      continue;
    if (a === "never") {
      s.push(p);
      continue;
    }
    const d = c.run({ value: t[p], issues: [] }, r);
    d instanceof Promise ? e.push(d.then((_) => me(_, n, p, t, l, h))) : me(d, n, p, t, l, h);
  }
  return s.length && n.issues.push({
    code: "unrecognized_keys",
    keys: s,
    input: t,
    inst: i
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const eo = /* @__PURE__ */ f("$ZodObject", (e, t) => {
  $.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const u = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const c = { ...u };
        return Object.defineProperty(t, "shape", {
          value: c
        }), c;
      }
    });
  }
  const r = ge(() => Nt(t));
  g(e._zod, "propValues", () => {
    const u = t.shape, c = {};
    for (const a in u) {
      const l = u[a]._zod;
      if (l.values) {
        c[a] ?? (c[a] = /* @__PURE__ */ new Set());
        for (const h of l.values)
          c[a].add(h);
      }
    }
    return c;
  });
  const o = se, i = t.catchall;
  let s;
  e._zod.parse = (u, c) => {
    s ?? (s = r.value);
    const a = u.value;
    if (!o(a))
      return u.issues.push({
        expected: "object",
        code: "invalid_type",
        input: a,
        inst: e
      }), u;
    u.value = {};
    const l = [], h = s.shape;
    for (const p of s.keys) {
      const d = h[p], _ = d._zod.optin === "optional", w = d._zod.optout === "optional", A = d._zod.run({ value: a[p], issues: [] }, c);
      A instanceof Promise ? l.push(A.then((k) => me(k, u, p, a, _, w))) : me(A, u, p, a, _, w);
    }
    return i ? Ct(l, a, u, c, r.value, e) : l.length ? Promise.all(l).then(() => u) : u;
  };
}), to = /* @__PURE__ */ f("$ZodObjectJIT", (e, t) => {
  eo.init(e, t);
  const n = e._zod.parse, r = ge(() => Nt(t)), o = (p) => {
    var re, R;
    const d = new kr(["shape", "payload", "ctx"]), _ = r.value, w = (x) => {
      const z = Ve(x);
      return `shape[${z}]._zod.run({ value: input[${z}], issues: [] }, ctx)`;
    };
    d.write("const input = payload.value;");
    const A = /* @__PURE__ */ Object.create(null);
    let k = 0;
    for (const x of _.keys)
      A[x] = `key_${k++}`;
    d.write("const newResult = {};");
    for (const x of _.keys) {
      const z = A[x], I = Ve(x), q = p[x], xe = ((re = q == null ? void 0 : q._zod) == null ? void 0 : re.optin) === "optional", qt = ((R = q == null ? void 0 : q._zod) == null ? void 0 : R.optout) === "optional";
      d.write(`const ${z} = ${w(x)};`), xe && qt ? d.write(`
        if (${z}.issues.length) {
          if (${I} in input) {
            payload.issues = payload.issues.concat(${z}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${I}, ...iss.path] : [${I}]
            })));
          }
        }
        
        if (${z}.value === undefined) {
          if (${I} in input) {
            newResult[${I}] = undefined;
          }
        } else {
          newResult[${I}] = ${z}.value;
        }
        
      `) : xe ? d.write(`
        if (${z}.issues.length) {
          payload.issues = payload.issues.concat(${z}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${I}, ...iss.path] : [${I}]
          })));
        }
        
        if (${z}.value === undefined) {
          if (${I} in input) {
            newResult[${I}] = undefined;
          }
        } else {
          newResult[${I}] = ${z}.value;
        }
        
      `) : d.write(`
        const ${z}_present = ${I} in input;
        if (${z}.issues.length) {
          payload.issues = payload.issues.concat(${z}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${I}, ...iss.path] : [${I}]
          })));
        }
        if (!${z}_present && !${z}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${I}]
          });
        }

        if (${z}_present) {
          if (${z}.value === undefined) {
            newResult[${I}] = undefined;
          } else {
            newResult[${I}] = ${z}.value;
          }
        }

      `);
    }
    d.write("payload.value = newResult;"), d.write("return payload;");
    const S = d.compile();
    return (x, z) => S(p, x, z);
  };
  let i;
  const s = se, u = !Pe.jitless, a = u && mn.value, l = t.catchall;
  let h;
  e._zod.parse = (p, d) => {
    h ?? (h = r.value);
    const _ = p.value;
    return s(_) ? u && a && (d == null ? void 0 : d.async) === !1 && d.jitless !== !0 ? (i || (i = o(t.shape)), p = i(p, d), l ? Ct([], _, p, d, h, e) : p) : n(p, d) : (p.issues.push({
      expected: "object",
      code: "invalid_type",
      input: _,
      inst: e
    }), p);
  };
});
function Ge(e, t, n, r) {
  for (const i of e)
    if (i.issues.length === 0)
      return t.value = i.value, t;
  const o = e.filter((i) => !Q(i));
  return o.length === 1 ? (t.value = o[0].value, o[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((i) => i.issues.map((s) => G(s, r, K())))
  }), t);
}
const jt = /* @__PURE__ */ f("$ZodUnion", (e, t) => {
  $.init(e, t), g(e._zod, "optin", () => t.options.some((r) => r._zod.optin === "optional") ? "optional" : void 0), g(e._zod, "optout", () => t.options.some((r) => r._zod.optout === "optional") ? "optional" : void 0), g(e._zod, "values", () => {
    if (t.options.every((r) => r._zod.values))
      return new Set(t.options.flatMap((r) => Array.from(r._zod.values)));
  }), g(e._zod, "pattern", () => {
    if (t.options.every((r) => r._zod.pattern)) {
      const r = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${r.map((o) => Ne(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1 ? t.options[0]._zod.run : null;
  e._zod.parse = (r, o) => {
    if (n)
      return n(r, o);
    let i = !1;
    const s = [];
    for (const u of t.options) {
      const c = u._zod.run({
        value: r.value,
        issues: []
      }, o);
      if (c instanceof Promise)
        s.push(c), i = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return i ? Promise.all(s).then((u) => Ge(u, r, e, o)) : Ge(s, r, e, o);
  };
}), no = /* @__PURE__ */ f("$ZodDiscriminatedUnion", (e, t) => {
  t.inclusive = !1, jt.init(e, t);
  const n = e._zod.parse;
  g(e._zod, "propValues", () => {
    const o = {};
    for (const i of t.options) {
      const s = i._zod.propValues;
      if (!s || Object.keys(s).length === 0)
        throw new Error(`Invalid discriminated union option at index "${t.options.indexOf(i)}"`);
      for (const [u, c] of Object.entries(s)) {
        o[u] || (o[u] = /* @__PURE__ */ new Set());
        for (const a of c)
          o[u].add(a);
      }
    }
    return o;
  });
  const r = ge(() => {
    var s;
    const o = t.options, i = /* @__PURE__ */ new Map();
    for (const u of o) {
      const c = (s = u._zod.propValues) == null ? void 0 : s[t.discriminator];
      if (!c || c.size === 0)
        throw new Error(`Invalid discriminated union option at index "${t.options.indexOf(u)}"`);
      for (const a of c) {
        if (i.has(a))
          throw new Error(`Duplicate discriminator value "${String(a)}"`);
        i.set(a, u);
      }
    }
    return i;
  });
  e._zod.parse = (o, i) => {
    const s = o.value;
    if (!se(s))
      return o.issues.push({
        code: "invalid_type",
        expected: "object",
        input: s,
        inst: e
      }), o;
    const u = r.value.get(s == null ? void 0 : s[t.discriminator]);
    return u ? u._zod.run(o, i) : t.unionFallback || i.direction === "backward" ? n(o, i) : (o.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: t.discriminator,
      options: Array.from(r.value.keys()),
      input: s,
      path: [t.discriminator],
      inst: e
    }), o);
  };
}), ro = /* @__PURE__ */ f("$ZodIntersection", (e, t) => {
  $.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value, i = t.left._zod.run({ value: o, issues: [] }, r), s = t.right._zod.run({ value: o, issues: [] }, r);
    return i instanceof Promise || s instanceof Promise ? Promise.all([i, s]).then(([c, a]) => Be(n, c, a)) : Be(n, i, s);
  };
});
function Te(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (ue(e) && ue(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((i) => n.indexOf(i) !== -1), o = { ...e, ...t };
    for (const i of r) {
      const s = Te(e[i], t[i]);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...s.mergeErrorPath]
        };
      o[i] = s.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const o = e[r], i = t[r], s = Te(o, i);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...s.mergeErrorPath]
        };
      n.push(s.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Be(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let o;
  for (const u of t.issues)
    if (u.code === "unrecognized_keys") {
      o ?? (o = u);
      for (const c of u.keys)
        r.has(c) || r.set(c, {}), r.get(c).l = !0;
    } else
      e.issues.push(u);
  for (const u of n.issues)
    if (u.code === "unrecognized_keys")
      for (const c of u.keys)
        r.has(c) || r.set(c, {}), r.get(c).r = !0;
    else
      e.issues.push(u);
  const i = [...r].filter(([, u]) => u.l && u.r).map(([u]) => u);
  if (i.length && o && e.issues.push({ ...o, keys: i }), Q(e))
    return e;
  const s = Te(t.value, n.value);
  if (!s.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(s.mergeErrorPath)}`);
  return e.value = s.data, e;
}
const oo = /* @__PURE__ */ f("$ZodEnum", (e, t) => {
  $.init(e, t);
  const n = gt(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((o) => _n.has(typeof o)).map((o) => typeof o == "string" ? te(o) : o.toString()).join("|")})$`), e._zod.parse = (o, i) => {
    const s = o.value;
    return r.has(s) || o.issues.push({
      code: "invalid_value",
      values: n,
      input: s,
      inst: e
    }), o;
  };
}), io = /* @__PURE__ */ f("$ZodLiteral", (e, t) => {
  if ($.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const n = new Set(t.values);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${t.values.map((r) => typeof r == "string" ? te(r) : r ? te(r.toString()) : String(r)).join("|")})$`), e._zod.parse = (r, o) => {
    const i = r.value;
    return n.has(i) || r.issues.push({
      code: "invalid_value",
      values: t.values,
      input: i,
      inst: e
    }), r;
  };
}), so = /* @__PURE__ */ f("$ZodTransform", (e, t) => {
  $.init(e, t), e._zod.optin = "optional", e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new vt(e.constructor.name);
    const o = t.transform(n.value, n);
    if (r.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((s) => (n.value = s, n.fallback = !0, n));
    if (o instanceof Promise)
      throw new ee();
    return n.value = o, n.fallback = !0, n;
  };
});
function Ye(e, t) {
  return t === void 0 && (e.issues.length || e.fallback) ? { issues: [], value: void 0 } : e;
}
const Rt = /* @__PURE__ */ f("$ZodOptional", (e, t) => {
  $.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", g(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), g(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Ne(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const o = n.value, i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((s) => Ye(s, o)) : Ye(i, o);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), uo = /* @__PURE__ */ f("$ZodExactOptional", (e, t) => {
  Rt.init(e, t), g(e._zod, "values", () => t.innerType._zod.values), g(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), co = /* @__PURE__ */ f("$ZodNullable", (e, t) => {
  $.init(e, t), g(e._zod, "optin", () => t.innerType._zod.optin), g(e._zod, "optout", () => t.innerType._zod.optout), g(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Ne(n.source)}|null)$`) : void 0;
  }), g(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), ao = /* @__PURE__ */ f("$ZodDefault", (e, t) => {
  $.init(e, t), e._zod.optin = "optional", g(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => qe(i, t)) : qe(o, t);
  };
});
function qe(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const lo = /* @__PURE__ */ f("$ZodPrefault", (e, t) => {
  $.init(e, t), e._zod.optin = "optional", g(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), fo = /* @__PURE__ */ f("$ZodNonOptional", (e, t) => {
  $.init(e, t), g(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => Xe(i, e)) : Xe(o, e);
  };
});
function Xe(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const ho = /* @__PURE__ */ f("$ZodCatch", (e, t) => {
  $.init(e, t), e._zod.optin = "optional", g(e._zod, "optout", () => t.innerType._zod.optout), g(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((s) => G(s, r, K()))
      },
      input: n.value
    }), n.issues = [], n.fallback = !0), n)) : (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((i) => G(i, r, K()))
      },
      input: n.value
    }), n.issues = [], n.fallback = !0), n);
  };
}), po = /* @__PURE__ */ f("$ZodPipe", (e, t) => {
  $.init(e, t), g(e._zod, "values", () => t.in._zod.values), g(e._zod, "optin", () => t.in._zod.optin), g(e._zod, "optout", () => t.out._zod.optout), g(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const i = t.out._zod.run(n, r);
      return i instanceof Promise ? i.then((s) => fe(s, t.in, r)) : fe(i, t.in, r);
    }
    const o = t.in._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => fe(i, t.out, r)) : fe(o, t.out, r);
  };
});
function fe(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues, fallback: e.fallback }, n);
}
const mo = /* @__PURE__ */ f("$ZodReadonly", (e, t) => {
  $.init(e, t), g(e._zod, "propValues", () => t.innerType._zod.propValues), g(e._zod, "values", () => t.innerType._zod.values), g(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), g(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then(Qe) : Qe(o);
  };
});
function Qe(e) {
  return e.value = Object.freeze(e.value), e;
}
const _o = /* @__PURE__ */ f("$ZodCustom", (e, t) => {
  D.init(e, t), $.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, o = t.fn(r);
    if (o instanceof Promise)
      return o.then((i) => et(i, n, r, e));
    et(o, n, r, e);
  };
});
function et(e, t, n, r) {
  if (!e) {
    const o = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (o.params = r._zod.def.params), t.issues.push(ce(o));
  }
}
var tt;
class vo {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const o = { ...r, ...this._map.get(t) };
      return Object.keys(o).length ? o : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function go() {
  return new vo();
}
(tt = globalThis).__zod_globalRegistry ?? (tt.__zod_globalRegistry = go());
const oe = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function wo(e, t) {
  return new e({
    type: "string",
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yo(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nt(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function bo(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zo(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ko(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $o(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Eo(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Zo(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Oo(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function To(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function So(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Io(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Po(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ao(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function No(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Co(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jo(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ro(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Do(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Uo(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Mo(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xo(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Fo(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Jo(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Lo(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ho(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Vo(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Wo(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ko(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function Go(e, t) {
  return new e({
    type: "never",
    ...m(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rt(e, t) {
  return new St({
    check: "less_than",
    ...m(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function ke(e, t) {
  return new St({
    check: "less_than",
    ...m(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function ot(e, t) {
  return new It({
    check: "greater_than",
    ...m(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function $e(e, t) {
  return new It({
    check: "greater_than",
    ...m(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function it(e, t) {
  return new fr({
    check: "multiple_of",
    ...m(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function Dt(e, t) {
  return new dr({
    check: "max_length",
    ...m(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function _e(e, t) {
  return new pr({
    check: "min_length",
    ...m(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ut(e, t) {
  return new mr({
    check: "length_equals",
    ...m(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function Bo(e, t) {
  return new _r({
    check: "string_format",
    format: "regex",
    ...m(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function Yo(e) {
  return new vr({
    check: "string_format",
    format: "lowercase",
    ...m(e)
  });
}
// @__NO_SIDE_EFFECTS__
function qo(e) {
  return new gr({
    check: "string_format",
    format: "uppercase",
    ...m(e)
  });
}
// @__NO_SIDE_EFFECTS__
function Xo(e, t) {
  return new wr({
    check: "string_format",
    format: "includes",
    ...m(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function Qo(e, t) {
  return new yr({
    check: "string_format",
    format: "starts_with",
    ...m(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function ei(e, t) {
  return new br({
    check: "string_format",
    format: "ends_with",
    ...m(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function ne(e) {
  return new zr({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function ti(e) {
  return /* @__PURE__ */ ne((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function ni() {
  return /* @__PURE__ */ ne((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function ri() {
  return /* @__PURE__ */ ne((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function oi() {
  return /* @__PURE__ */ ne((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function ii() {
  return /* @__PURE__ */ ne((e) => pn(e));
}
// @__NO_SIDE_EFFECTS__
function si(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...m(n)
  });
}
// @__NO_SIDE_EFFECTS__
function ui(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...m(n)
  });
}
// @__NO_SIDE_EFFECTS__
function ci(e, t) {
  const n = /* @__PURE__ */ ai((r) => (r.addIssue = (o) => {
    if (typeof o == "string")
      r.issues.push(ce(o, r.value, n._zod.def));
    else {
      const i = o;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = r.value), i.inst ?? (i.inst = n), i.continue ?? (i.continue = !n._zod.def.abort), r.issues.push(ce(i));
    }
  }, e(r.value, r)), t);
  return n;
}
// @__NO_SIDE_EFFECTS__
function ai(e, t) {
  const n = new D({
    check: "custom",
    ...m(t)
  });
  return n._zod.check = e, n;
}
function Mt(e) {
  let t = (e == null ? void 0 : e.target) ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: (e == null ? void 0 : e.metadata) ?? oe,
    target: t,
    unrepresentable: (e == null ? void 0 : e.unrepresentable) ?? "throw",
    override: (e == null ? void 0 : e.override) ?? (() => {
    }),
    io: (e == null ? void 0 : e.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: (e == null ? void 0 : e.cycles) ?? "ref",
    reused: (e == null ? void 0 : e.reused) ?? "inline",
    external: (e == null ? void 0 : e.external) ?? void 0
  };
}
function P(e, t, n = { path: [], schemaPath: [] }) {
  var l, h;
  var r;
  const o = e._zod.def, i = t.seen.get(e);
  if (i)
    return i.count++, n.schemaPath.includes(e) && (i.cycle = n.path), i.schema;
  const s = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, s);
  const u = (h = (l = e._zod).toJSONSchema) == null ? void 0 : h.call(l);
  if (u)
    s.schema = u;
  else {
    const p = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, s.schema, p);
    else {
      const _ = s.schema, w = t.processors[o.type];
      if (!w)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${o.type}`);
      w(e, t, _, p);
    }
    const d = e._zod.parent;
    d && (s.ref || (s.ref = d), P(d, t, p), t.seen.get(d).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(s.schema, c), t.io === "input" && j(e) && (delete s.schema.examples, delete s.schema.default), t.io === "input" && "_prefault" in s.schema && ((r = s.schema).default ?? (r.default = s.schema._prefault)), delete s.schema._prefault, t.seen.get(e).schema;
}
function xt(e, t) {
  var s, u, c, a;
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = /* @__PURE__ */ new Map();
  for (const l of e.seen.entries()) {
    const h = (s = e.metadataRegistry.get(l[0])) == null ? void 0 : s.id;
    if (h) {
      const p = r.get(h);
      if (p && p !== l[0])
        throw new Error(`Duplicate schema id "${h}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      r.set(h, l[0]);
    }
  }
  const o = (l) => {
    var w;
    const h = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const A = (w = e.external.registry.get(l[0])) == null ? void 0 : w.id, k = e.external.uri ?? ((re) => re);
      if (A)
        return { ref: k(A) };
      const S = l[1].defId ?? l[1].schema.id ?? `schema${e.counter++}`;
      return l[1].defId = S, { defId: S, ref: `${k("__shared")}#/${h}/${S}` };
    }
    if (l[1] === n)
      return { ref: "#" };
    const d = `#/${h}/`, _ = l[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: _, ref: d + _ };
  }, i = (l) => {
    if (l[1].schema.$ref)
      return;
    const h = l[1], { ref: p, defId: d } = o(l);
    h.def = { ...h.schema }, d && (h.defId = d);
    const _ = h.schema;
    for (const w in _)
      delete _[w];
    _.$ref = p;
  };
  if (e.cycles === "throw")
    for (const l of e.seen.entries()) {
      const h = l[1];
      if (h.cycle)
        throw new Error(`Cycle detected: #/${(u = h.cycle) == null ? void 0 : u.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const l of e.seen.entries()) {
    const h = l[1];
    if (t === l[0]) {
      i(l);
      continue;
    }
    if (e.external) {
      const d = (c = e.external.registry.get(l[0])) == null ? void 0 : c.id;
      if (t !== l[0] && d) {
        i(l);
        continue;
      }
    }
    if ((a = e.metadataRegistry.get(l[0])) == null ? void 0 : a.id) {
      i(l);
      continue;
    }
    if (h.cycle) {
      i(l);
      continue;
    }
    if (h.count > 1 && e.reused === "ref") {
      i(l);
      continue;
    }
  }
}
function Ft(e, t) {
  var u, c, a, l;
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = (h) => {
    const p = e.seen.get(h);
    if (p.ref === null)
      return;
    const d = p.def ?? p.schema, _ = { ...d }, w = p.ref;
    if (p.ref = null, w) {
      r(w);
      const k = e.seen.get(w), S = k.schema;
      if (S.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (d.allOf = d.allOf ?? [], d.allOf.push(S)) : Object.assign(d, S), Object.assign(d, _), h._zod.parent === w)
        for (const R in d)
          R === "$ref" || R === "allOf" || R in _ || delete d[R];
      if (S.$ref && k.def)
        for (const R in d)
          R === "$ref" || R === "allOf" || R in k.def && JSON.stringify(d[R]) === JSON.stringify(k.def[R]) && delete d[R];
    }
    const A = h._zod.parent;
    if (A && A !== w) {
      r(A);
      const k = e.seen.get(A);
      if (k != null && k.schema.$ref && (d.$ref = k.schema.$ref, k.def))
        for (const S in d)
          S === "$ref" || S === "allOf" || S in k.def && JSON.stringify(d[S]) === JSON.stringify(k.def[S]) && delete d[S];
    }
    e.override({
      zodSchema: h,
      jsonSchema: d,
      path: p.path ?? []
    });
  };
  for (const h of [...e.seen.entries()].reverse())
    r(h[0]);
  const o = {};
  if (e.target === "draft-2020-12" ? o.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? o.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? o.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (u = e.external) != null && u.uri) {
    const h = (c = e.external.registry.get(t)) == null ? void 0 : c.id;
    if (!h)
      throw new Error("Schema is missing an `id` property");
    o.$id = e.external.uri(h);
  }
  Object.assign(o, n.def ?? n.schema);
  const i = (a = e.metadataRegistry.get(t)) == null ? void 0 : a.id;
  i !== void 0 && o.id === i && delete o.id;
  const s = ((l = e.external) == null ? void 0 : l.defs) ?? {};
  for (const h of e.seen.entries()) {
    const p = h[1];
    p.def && p.defId && (p.def.id === p.defId && delete p.def.id, s[p.defId] = p.def);
  }
  e.external || Object.keys(s).length > 0 && (e.target === "draft-2020-12" ? o.$defs = s : o.definitions = s);
  try {
    const h = JSON.parse(JSON.stringify(o));
    return Object.defineProperty(h, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: ve(t, "input", e.processors),
          output: ve(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), h;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function j(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return j(r.element, n);
  if (r.type === "set")
    return j(r.valueType, n);
  if (r.type === "lazy")
    return j(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return j(r.innerType, n);
  if (r.type === "intersection")
    return j(r.left, n) || j(r.right, n);
  if (r.type === "record" || r.type === "map")
    return j(r.keyType, n) || j(r.valueType, n);
  if (r.type === "pipe")
    return e._zod.traits.has("$ZodCodec") ? !0 : j(r.in, n) || j(r.out, n);
  if (r.type === "object") {
    for (const o in r.shape)
      if (j(r.shape[o], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const o of r.options)
      if (j(o, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const o of r.items)
      if (j(o, n))
        return !0;
    return !!(r.rest && j(r.rest, n));
  }
  return !1;
}
const li = (e, t = {}) => (n) => {
  const r = Mt({ ...n, processors: t });
  return P(e, r), xt(r, e), Ft(r, e);
}, ve = (e, t, n = {}) => (r) => {
  const { libraryOptions: o, target: i } = r ?? {}, s = Mt({ ...o ?? {}, target: i, io: t, processors: n });
  return P(e, s), xt(s, e), Ft(s, e);
}, fi = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, hi = (e, t, n, r) => {
  const o = n;
  o.type = "string";
  const { minimum: i, maximum: s, format: u, patterns: c, contentEncoding: a } = e._zod.bag;
  if (typeof i == "number" && (o.minLength = i), typeof s == "number" && (o.maxLength = s), u && (o.format = fi[u] ?? u, o.format === "" && delete o.format, u === "time" && delete o.format), a && (o.contentEncoding = a), c && c.size > 0) {
    const l = [...c];
    l.length === 1 ? o.pattern = l[0].source : l.length > 1 && (o.allOf = [
      ...l.map((h) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: h.source
      }))
    ]);
  }
}, di = (e, t, n, r) => {
  const o = n, { minimum: i, maximum: s, format: u, multipleOf: c, exclusiveMaximum: a, exclusiveMinimum: l } = e._zod.bag;
  typeof u == "string" && u.includes("int") ? o.type = "integer" : o.type = "number";
  const h = typeof l == "number" && l >= (i ?? Number.NEGATIVE_INFINITY), p = typeof a == "number" && a <= (s ?? Number.POSITIVE_INFINITY), d = t.target === "draft-04" || t.target === "openapi-3.0";
  h ? d ? (o.minimum = l, o.exclusiveMinimum = !0) : o.exclusiveMinimum = l : typeof i == "number" && (o.minimum = i), p ? d ? (o.maximum = a, o.exclusiveMaximum = !0) : o.exclusiveMaximum = a : typeof s == "number" && (o.maximum = s), typeof c == "number" && (o.multipleOf = c);
}, pi = (e, t, n, r) => {
  n.not = {};
}, mi = (e, t, n, r) => {
}, _i = (e, t, n, r) => {
  const o = e._zod.def, i = gt(o.entries);
  i.every((s) => typeof s == "number") && (n.type = "number"), i.every((s) => typeof s == "string") && (n.type = "string"), n.enum = i;
}, vi = (e, t, n, r) => {
  const o = e._zod.def, i = [];
  for (const s of o.values)
    if (s === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof s == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      i.push(Number(s));
    } else
      i.push(s);
  if (i.length !== 0) if (i.length === 1) {
    const s = i[0];
    n.type = s === null ? "null" : typeof s, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [s] : n.const = s;
  } else
    i.every((s) => typeof s == "number") && (n.type = "number"), i.every((s) => typeof s == "string") && (n.type = "string"), i.every((s) => typeof s == "boolean") && (n.type = "boolean"), i.every((s) => s === null) && (n.type = "null"), n.enum = i;
}, gi = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, wi = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, yi = (e, t, n, r) => {
  const o = n, i = e._zod.def, { minimum: s, maximum: u } = e._zod.bag;
  typeof s == "number" && (o.minItems = s), typeof u == "number" && (o.maxItems = u), o.type = "array", o.items = P(i.element, t, {
    ...r,
    path: [...r.path, "items"]
  });
}, bi = (e, t, n, r) => {
  var a;
  const o = n, i = e._zod.def;
  o.type = "object", o.properties = {};
  const s = i.shape;
  for (const l in s)
    o.properties[l] = P(s[l], t, {
      ...r,
      path: [...r.path, "properties", l]
    });
  const u = new Set(Object.keys(s)), c = new Set([...u].filter((l) => {
    const h = i.shape[l]._zod;
    return t.io === "input" ? h.optin === void 0 : h.optout === void 0;
  }));
  c.size > 0 && (o.required = Array.from(c)), ((a = i.catchall) == null ? void 0 : a._zod.def.type) === "never" ? o.additionalProperties = !1 : i.catchall ? i.catchall && (o.additionalProperties = P(i.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, zi = (e, t, n, r) => {
  const o = e._zod.def, i = o.inclusive === !1, s = o.options.map((u, c) => P(u, t, {
    ...r,
    path: [...r.path, i ? "oneOf" : "anyOf", c]
  }));
  i ? n.oneOf = s : n.anyOf = s;
}, ki = (e, t, n, r) => {
  const o = e._zod.def, i = P(o.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), s = P(o.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), u = (a) => "allOf" in a && Object.keys(a).length === 1, c = [
    ...u(i) ? i.allOf : [i],
    ...u(s) ? s.allOf : [s]
  ];
  n.allOf = c;
}, $i = (e, t, n, r) => {
  const o = e._zod.def, i = P(o.innerType, t, r), s = t.seen.get(e);
  t.target === "openapi-3.0" ? (s.ref = o.innerType, n.nullable = !0) : n.anyOf = [i, { type: "null" }];
}, Ei = (e, t, n, r) => {
  const o = e._zod.def;
  P(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType;
}, Zi = (e, t, n, r) => {
  const o = e._zod.def;
  P(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType, n.default = JSON.parse(JSON.stringify(o.defaultValue));
}, Oi = (e, t, n, r) => {
  const o = e._zod.def;
  P(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(o.defaultValue)));
}, Ti = (e, t, n, r) => {
  const o = e._zod.def;
  P(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType;
  let s;
  try {
    s = o.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = s;
}, Si = (e, t, n, r) => {
  const o = e._zod.def, i = o.in._zod.traits.has("$ZodTransform"), s = t.io === "input" ? i ? o.out : o.in : o.out;
  P(s, t, r);
  const u = t.seen.get(e);
  u.ref = s;
}, Ii = (e, t, n, r) => {
  const o = e._zod.def;
  P(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType, n.readOnly = !0;
}, Jt = (e, t, n, r) => {
  const o = e._zod.def;
  P(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType;
}, Pi = /* @__PURE__ */ f("ZodISODateTime", (e, t) => {
  Rr.init(e, t), b.init(e, t);
});
function Ai(e) {
  return /* @__PURE__ */ Fo(Pi, e);
}
const Ni = /* @__PURE__ */ f("ZodISODate", (e, t) => {
  Dr.init(e, t), b.init(e, t);
});
function Ci(e) {
  return /* @__PURE__ */ Jo(Ni, e);
}
const ji = /* @__PURE__ */ f("ZodISOTime", (e, t) => {
  Ur.init(e, t), b.init(e, t);
});
function Ri(e) {
  return /* @__PURE__ */ Lo(ji, e);
}
const Di = /* @__PURE__ */ f("ZodISODuration", (e, t) => {
  Mr.init(e, t), b.init(e, t);
});
function Ui(e) {
  return /* @__PURE__ */ Ho(Di, e);
}
const Lt = (e, t) => {
  kt.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => Tn(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => On(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, Oe, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, Oe, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Mi = /* @__PURE__ */ f("ZodError", Lt), U = /* @__PURE__ */ f("ZodError", Lt, {
  Parent: Error
}), xi = /* @__PURE__ */ je(U), Fi = /* @__PURE__ */ Re(U), Ji = /* @__PURE__ */ we(U), Li = /* @__PURE__ */ ye(U), Hi = /* @__PURE__ */ Pn(U), Vi = /* @__PURE__ */ An(U), Wi = /* @__PURE__ */ Nn(U), Ki = /* @__PURE__ */ Cn(U), Gi = /* @__PURE__ */ jn(U), Bi = /* @__PURE__ */ Rn(U), Yi = /* @__PURE__ */ Dn(U), qi = /* @__PURE__ */ Un(U), st = /* @__PURE__ */ new WeakMap();
function ae(e, t, n) {
  const r = Object.getPrototypeOf(e);
  let o = st.get(r);
  if (o || (o = /* @__PURE__ */ new Set(), st.set(r, o)), !o.has(t)) {
    o.add(t);
    for (const i in n) {
      const s = n[i];
      Object.defineProperty(r, i, {
        configurable: !0,
        enumerable: !1,
        get() {
          const u = s.bind(this);
          return Object.defineProperty(this, i, {
            configurable: !0,
            writable: !0,
            enumerable: !0,
            value: u
          }), u;
        },
        set(u) {
          Object.defineProperty(this, i, {
            configurable: !0,
            writable: !0,
            enumerable: !0,
            value: u
          });
        }
      });
    }
  }
}
const E = /* @__PURE__ */ f("ZodType", (e, t) => ($.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: ve(e, "input"),
    output: ve(e, "output")
  }
}), e.toJSONSchema = li(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.parse = (n, r) => xi(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => Ji(e, n, r), e.parseAsync = async (n, r) => Fi(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => Li(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => Hi(e, n, r), e.decode = (n, r) => Vi(e, n, r), e.encodeAsync = async (n, r) => Wi(e, n, r), e.decodeAsync = async (n, r) => Ki(e, n, r), e.safeEncode = (n, r) => Gi(e, n, r), e.safeDecode = (n, r) => Bi(e, n, r), e.safeEncodeAsync = async (n, r) => Yi(e, n, r), e.safeDecodeAsync = async (n, r) => qi(e, n, r), ae(e, "ZodType", {
  check(...n) {
    const r = this.def;
    return this.clone(H(r, {
      checks: [
        ...r.checks ?? [],
        ...n.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
      ]
    }), { parent: !0 });
  },
  with(...n) {
    return this.check(...n);
  },
  clone(n, r) {
    return V(this, n, r);
  },
  brand() {
    return this;
  },
  register(n, r) {
    return n.add(this, r), this;
  },
  refine(n, r) {
    return this.check(Vs(n, r));
  },
  superRefine(n, r) {
    return this.check(Ws(n, r));
  },
  overwrite(n) {
    return this.check(/* @__PURE__ */ ne(n));
  },
  optional() {
    return ft(this);
  },
  exactOptional() {
    return As(this);
  },
  nullable() {
    return ht(this);
  },
  nullish() {
    return ft(ht(this));
  },
  nonoptional(n) {
    return Us(this, n);
  },
  array() {
    return bs(this);
  },
  or(n) {
    return ks([this, n]);
  },
  and(n) {
    return Zs(this, n);
  },
  transform(n) {
    return dt(this, Is(n));
  },
  default(n) {
    return js(this, n);
  },
  prefault(n) {
    return Ds(this, n);
  },
  catch(n) {
    return xs(this, n);
  },
  pipe(n) {
    return dt(this, n);
  },
  readonly() {
    return Ls(this);
  },
  describe(n) {
    const r = this.clone();
    return oe.add(r, { description: n }), r;
  },
  meta(...n) {
    if (n.length === 0)
      return oe.get(this);
    const r = this.clone();
    return oe.add(r, n[0]), r;
  },
  isOptional() {
    return this.safeParse(void 0).success;
  },
  isNullable() {
    return this.safeParse(null).success;
  },
  apply(n) {
    return n(this);
  }
}), Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = oe.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e)), Ht = /* @__PURE__ */ f("_ZodString", (e, t) => {
  De.init(e, t), E.init(e, t), e._zod.processJSONSchema = (r, o, i) => hi(e, r, o);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, ae(e, "_ZodString", {
    regex(...r) {
      return this.check(/* @__PURE__ */ Bo(...r));
    },
    includes(...r) {
      return this.check(/* @__PURE__ */ Xo(...r));
    },
    startsWith(...r) {
      return this.check(/* @__PURE__ */ Qo(...r));
    },
    endsWith(...r) {
      return this.check(/* @__PURE__ */ ei(...r));
    },
    min(...r) {
      return this.check(/* @__PURE__ */ _e(...r));
    },
    max(...r) {
      return this.check(/* @__PURE__ */ Dt(...r));
    },
    length(...r) {
      return this.check(/* @__PURE__ */ Ut(...r));
    },
    nonempty(...r) {
      return this.check(/* @__PURE__ */ _e(1, ...r));
    },
    lowercase(r) {
      return this.check(/* @__PURE__ */ Yo(r));
    },
    uppercase(r) {
      return this.check(/* @__PURE__ */ qo(r));
    },
    trim() {
      return this.check(/* @__PURE__ */ ni());
    },
    normalize(...r) {
      return this.check(/* @__PURE__ */ ti(...r));
    },
    toLowerCase() {
      return this.check(/* @__PURE__ */ ri());
    },
    toUpperCase() {
      return this.check(/* @__PURE__ */ oi());
    },
    slugify() {
      return this.check(/* @__PURE__ */ ii());
    }
  });
}), Xi = /* @__PURE__ */ f("ZodString", (e, t) => {
  De.init(e, t), Ht.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ yo(Qi, n)), e.url = (n) => e.check(/* @__PURE__ */ Eo(es, n)), e.jwt = (n) => e.check(/* @__PURE__ */ xo(ms, n)), e.emoji = (n) => e.check(/* @__PURE__ */ Zo(ts, n)), e.guid = (n) => e.check(/* @__PURE__ */ nt(ut, n)), e.uuid = (n) => e.check(/* @__PURE__ */ bo(he, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ zo(he, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ ko(he, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ $o(he, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ Oo(ns, n)), e.guid = (n) => e.check(/* @__PURE__ */ nt(ut, n)), e.cuid = (n) => e.check(/* @__PURE__ */ To(rs, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ So(os, n)), e.ulid = (n) => e.check(/* @__PURE__ */ Io(is, n)), e.base64 = (n) => e.check(/* @__PURE__ */ Do(hs, n)), e.base64url = (n) => e.check(/* @__PURE__ */ Uo(ds, n)), e.xid = (n) => e.check(/* @__PURE__ */ Po(ss, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ Ao(us, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ No(cs, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ Co(as, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ jo(ls, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ Ro(fs, n)), e.e164 = (n) => e.check(/* @__PURE__ */ Mo(ps, n)), e.datetime = (n) => e.check(Ai(n)), e.date = (n) => e.check(Ci(n)), e.time = (n) => e.check(Ri(n)), e.duration = (n) => e.check(Ui(n));
});
function L(e) {
  return /* @__PURE__ */ wo(Xi, e);
}
const b = /* @__PURE__ */ f("ZodStringFormat", (e, t) => {
  y.init(e, t), Ht.init(e, t);
}), Qi = /* @__PURE__ */ f("ZodEmail", (e, t) => {
  Or.init(e, t), b.init(e, t);
}), ut = /* @__PURE__ */ f("ZodGUID", (e, t) => {
  Er.init(e, t), b.init(e, t);
}), he = /* @__PURE__ */ f("ZodUUID", (e, t) => {
  Zr.init(e, t), b.init(e, t);
}), es = /* @__PURE__ */ f("ZodURL", (e, t) => {
  Tr.init(e, t), b.init(e, t);
}), ts = /* @__PURE__ */ f("ZodEmoji", (e, t) => {
  Sr.init(e, t), b.init(e, t);
}), ns = /* @__PURE__ */ f("ZodNanoID", (e, t) => {
  Ir.init(e, t), b.init(e, t);
}), rs = /* @__PURE__ */ f("ZodCUID", (e, t) => {
  Pr.init(e, t), b.init(e, t);
}), os = /* @__PURE__ */ f("ZodCUID2", (e, t) => {
  Ar.init(e, t), b.init(e, t);
}), is = /* @__PURE__ */ f("ZodULID", (e, t) => {
  Nr.init(e, t), b.init(e, t);
}), ss = /* @__PURE__ */ f("ZodXID", (e, t) => {
  Cr.init(e, t), b.init(e, t);
}), us = /* @__PURE__ */ f("ZodKSUID", (e, t) => {
  jr.init(e, t), b.init(e, t);
}), cs = /* @__PURE__ */ f("ZodIPv4", (e, t) => {
  xr.init(e, t), b.init(e, t);
}), as = /* @__PURE__ */ f("ZodIPv6", (e, t) => {
  Fr.init(e, t), b.init(e, t);
}), ls = /* @__PURE__ */ f("ZodCIDRv4", (e, t) => {
  Jr.init(e, t), b.init(e, t);
}), fs = /* @__PURE__ */ f("ZodCIDRv6", (e, t) => {
  Lr.init(e, t), b.init(e, t);
}), hs = /* @__PURE__ */ f("ZodBase64", (e, t) => {
  Hr.init(e, t), b.init(e, t);
}), ds = /* @__PURE__ */ f("ZodBase64URL", (e, t) => {
  Wr.init(e, t), b.init(e, t);
}), ps = /* @__PURE__ */ f("ZodE164", (e, t) => {
  Kr.init(e, t), b.init(e, t);
}), ms = /* @__PURE__ */ f("ZodJWT", (e, t) => {
  Br.init(e, t), b.init(e, t);
}), Vt = /* @__PURE__ */ f("ZodNumber", (e, t) => {
  At.init(e, t), E.init(e, t), e._zod.processJSONSchema = (r, o, i) => di(e, r, o), ae(e, "ZodNumber", {
    gt(r, o) {
      return this.check(/* @__PURE__ */ ot(r, o));
    },
    gte(r, o) {
      return this.check(/* @__PURE__ */ $e(r, o));
    },
    min(r, o) {
      return this.check(/* @__PURE__ */ $e(r, o));
    },
    lt(r, o) {
      return this.check(/* @__PURE__ */ rt(r, o));
    },
    lte(r, o) {
      return this.check(/* @__PURE__ */ ke(r, o));
    },
    max(r, o) {
      return this.check(/* @__PURE__ */ ke(r, o));
    },
    int(r) {
      return this.check(at(r));
    },
    safe(r) {
      return this.check(at(r));
    },
    positive(r) {
      return this.check(/* @__PURE__ */ ot(0, r));
    },
    nonnegative(r) {
      return this.check(/* @__PURE__ */ $e(0, r));
    },
    negative(r) {
      return this.check(/* @__PURE__ */ rt(0, r));
    },
    nonpositive(r) {
      return this.check(/* @__PURE__ */ ke(0, r));
    },
    multipleOf(r, o) {
      return this.check(/* @__PURE__ */ it(r, o));
    },
    step(r, o) {
      return this.check(/* @__PURE__ */ it(r, o));
    },
    finite() {
      return this;
    }
  });
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function ct(e) {
  return /* @__PURE__ */ Vo(Vt, e);
}
const _s = /* @__PURE__ */ f("ZodNumberFormat", (e, t) => {
  Yr.init(e, t), Vt.init(e, t);
});
function at(e) {
  return /* @__PURE__ */ Wo(_s, e);
}
const vs = /* @__PURE__ */ f("ZodUnknown", (e, t) => {
  qr.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => mi();
});
function lt() {
  return /* @__PURE__ */ Ko(vs);
}
const gs = /* @__PURE__ */ f("ZodNever", (e, t) => {
  Xr.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => pi(e, n, r);
});
function ws(e) {
  return /* @__PURE__ */ Go(gs, e);
}
const ys = /* @__PURE__ */ f("ZodArray", (e, t) => {
  Qr.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => yi(e, n, r, o), e.element = t.element, ae(e, "ZodArray", {
    min(n, r) {
      return this.check(/* @__PURE__ */ _e(n, r));
    },
    nonempty(n) {
      return this.check(/* @__PURE__ */ _e(1, n));
    },
    max(n, r) {
      return this.check(/* @__PURE__ */ Dt(n, r));
    },
    length(n, r) {
      return this.check(/* @__PURE__ */ Ut(n, r));
    },
    unwrap() {
      return this.element;
    }
  });
});
function bs(e, t) {
  return /* @__PURE__ */ si(ys, e, t);
}
const zs = /* @__PURE__ */ f("ZodObject", (e, t) => {
  to.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => bi(e, n, r, o), g(e, "shape", () => t.shape), ae(e, "ZodObject", {
    keyof() {
      return Os(Object.keys(this._zod.def.shape));
    },
    catchall(n) {
      return this.clone({ ...this._zod.def, catchall: n });
    },
    passthrough() {
      return this.clone({ ...this._zod.def, catchall: lt() });
    },
    loose() {
      return this.clone({ ...this._zod.def, catchall: lt() });
    },
    strict() {
      return this.clone({ ...this._zod.def, catchall: ws() });
    },
    strip() {
      return this.clone({ ...this._zod.def, catchall: void 0 });
    },
    extend(n) {
      return bn(this, n);
    },
    safeExtend(n) {
      return zn(this, n);
    },
    merge(n) {
      return kn(this, n);
    },
    pick(n) {
      return wn(this, n);
    },
    omit(n) {
      return yn(this, n);
    },
    partial(...n) {
      return $n(Gt, this, n[0]);
    },
    required(...n) {
      return En(Bt, this, n[0]);
    }
  });
});
function O(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...m(t)
  };
  return new zs(n);
}
const Wt = /* @__PURE__ */ f("ZodUnion", (e, t) => {
  jt.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => zi(e, n, r, o), e.options = t.options;
});
function ks(e, t) {
  return new Wt({
    type: "union",
    options: e,
    ...m(t)
  });
}
const $s = /* @__PURE__ */ f("ZodDiscriminatedUnion", (e, t) => {
  Wt.init(e, t), no.init(e, t);
});
function Kt(e, t, n) {
  return new $s({
    type: "union",
    options: t,
    discriminator: e,
    ...m(n)
  });
}
const Es = /* @__PURE__ */ f("ZodIntersection", (e, t) => {
  ro.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => ki(e, n, r, o);
});
function Zs(e, t) {
  return new Es({
    type: "intersection",
    left: e,
    right: t
  });
}
const Se = /* @__PURE__ */ f("ZodEnum", (e, t) => {
  oo.init(e, t), E.init(e, t), e._zod.processJSONSchema = (r, o, i) => _i(e, r, o), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, o) => {
    const i = {};
    for (const s of r)
      if (n.has(s))
        i[s] = t.entries[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new Se({
      ...t,
      checks: [],
      ...m(o),
      entries: i
    });
  }, e.exclude = (r, o) => {
    const i = { ...t.entries };
    for (const s of r)
      if (n.has(s))
        delete i[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new Se({
      ...t,
      checks: [],
      ...m(o),
      entries: i
    });
  };
});
function Os(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new Se({
    type: "enum",
    entries: n,
    ...m(t)
  });
}
const Ts = /* @__PURE__ */ f("ZodLiteral", (e, t) => {
  io.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => vi(e, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function T(e, t) {
  return new Ts({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...m(t)
  });
}
const Ss = /* @__PURE__ */ f("ZodTransform", (e, t) => {
  so.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => wi(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new vt(e.constructor.name);
    n.addIssue = (i) => {
      if (typeof i == "string")
        n.issues.push(ce(i, n.value, t));
      else {
        const s = i;
        s.fatal && (s.continue = !1), s.code ?? (s.code = "custom"), s.input ?? (s.input = n.value), s.inst ?? (s.inst = e), n.issues.push(ce(s));
      }
    };
    const o = t.transform(n.value, n);
    return o instanceof Promise ? o.then((i) => (n.value = i, n.fallback = !0, n)) : (n.value = o, n.fallback = !0, n);
  };
});
function Is(e) {
  return new Ss({
    type: "transform",
    transform: e
  });
}
const Gt = /* @__PURE__ */ f("ZodOptional", (e, t) => {
  Rt.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => Jt(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function ft(e) {
  return new Gt({
    type: "optional",
    innerType: e
  });
}
const Ps = /* @__PURE__ */ f("ZodExactOptional", (e, t) => {
  uo.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => Jt(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function As(e) {
  return new Ps({
    type: "optional",
    innerType: e
  });
}
const Ns = /* @__PURE__ */ f("ZodNullable", (e, t) => {
  co.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => $i(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function ht(e) {
  return new Ns({
    type: "nullable",
    innerType: e
  });
}
const Cs = /* @__PURE__ */ f("ZodDefault", (e, t) => {
  ao.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => Zi(e, n, r, o), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function js(e, t) {
  return new Cs({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : yt(t);
    }
  });
}
const Rs = /* @__PURE__ */ f("ZodPrefault", (e, t) => {
  lo.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => Oi(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function Ds(e, t) {
  return new Rs({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : yt(t);
    }
  });
}
const Bt = /* @__PURE__ */ f("ZodNonOptional", (e, t) => {
  fo.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => Ei(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function Us(e, t) {
  return new Bt({
    type: "nonoptional",
    innerType: e,
    ...m(t)
  });
}
const Ms = /* @__PURE__ */ f("ZodCatch", (e, t) => {
  ho.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => Ti(e, n, r, o), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function xs(e, t) {
  return new Ms({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Fs = /* @__PURE__ */ f("ZodPipe", (e, t) => {
  po.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => Si(e, n, r, o), e.in = t.in, e.out = t.out;
});
function dt(e, t) {
  return new Fs({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Js = /* @__PURE__ */ f("ZodReadonly", (e, t) => {
  mo.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => Ii(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function Ls(e) {
  return new Js({
    type: "readonly",
    innerType: e
  });
}
const Hs = /* @__PURE__ */ f("ZodCustom", (e, t) => {
  _o.init(e, t), E.init(e, t), e._zod.processJSONSchema = (n, r, o) => gi(e, n);
});
function Vs(e, t = {}) {
  return /* @__PURE__ */ ui(Hs, e, t);
}
function Ws(e, t) {
  return /* @__PURE__ */ ci(e, t);
}
const Ks = O({
  iat: ct(),
  // Issued at (timestamp, seconds since unix epoch)
  exp: ct()
  // Expires at (timestamp, seconds since unix epoch)
  // There are other values that we don't care about
});
Kt("auth", [
  O({
    auth: T("Case"),
    caseId: L(),
    corporateId: L(),
    clientId: L()
  }),
  O({
    auth: T("Client"),
    corporateId: L(),
    clientId: L()
  }),
  O({
    auth: T("Employer"),
    employerId: L(),
    clientId: L().nullable()
  }),
  O({ auth: T("Nothing") })
]);
function Gs(e) {
  const t = Ks.parse(
    JSON.parse(rn.from(e.split(".")[1], "base64").toString())
  );
  return {
    iat: ie.Timestamp.fromUnixTimeSeconds(t.iat),
    exp: ie.Timestamp.fromUnixTimeSeconds(t.exp)
  };
}
function Yt(e) {
  return { kitFetch: e == null ? void 0 : e.kitFetch, timeoutMs: e == null ? void 0 : e.timeoutMs };
}
function Ee(e, t) {
  return t instanceof Map ? Object.fromEntries(t.entries()) : t;
}
const Bs = ie.Milliseconds.minute * 5;
function Ie(e) {
  const t = Gs(e);
  return ie.Timestamp.addMilliseconds(
    ie.Timestamp.now(),
    Bs
  ) > t.exp;
}
function Ys(e, t) {
  const n = (r) => JSON.stringify([...r.entries()].sort());
  return n(new Headers(e)) === n(t);
}
class qs {
  constructor(t) {
    N(this, "authTokenMutex");
    N(this, "resolveAuthTokenMutex");
    N(this, "clientTokenMutex");
    N(this, "resolveClientTokenMutex");
    this.apiUrl = t, this.authTokenMutex = void 0, this.resolveAuthTokenMutex = void 0, this.clientTokenMutex = void 0, this.resolveClientTokenMutex = void 0;
  }
  async fetchResponse(t, n = void 0, r = void 0) {
    let o;
    return B(r) ? o = await r(t, n) : o = await fetch(t, n), o;
  }
  async attemptFetch(t, n, r, o) {
    if (o === void 0)
      return this.fetchResponse(t, n, r);
    const i = new AbortController(), s = n.signal, u = () => i.abort(s == null ? void 0 : s.reason);
    s != null && s.aborted ? u() : s == null || s.addEventListener("abort", u, { once: !0 });
    const c = setTimeout(() => {
      i.abort(new DOMException("Request timed out", "TimeoutError"));
    }, o);
    try {
      return await this.fetchResponse(t, { ...n, signal: i.signal }, r);
    } finally {
      clearTimeout(c), s == null || s.removeEventListener("abort", u);
    }
  }
  async api(t, n, r, o, i = {}) {
    const { kitFetch: s, timeoutMs: u, retryCounter: c = 1 } = i, a = await this.attemptFetch(t, n, s, u);
    if (!a.ok) {
      if (a.status === 401 && c > 0) {
        const h = await o(n);
        if (h.isErr()) return v(h.error);
        if (!Ys(n.headers, h.value))
          return n.headers = h.value, this.api(t, n, r, o, {
            ...i,
            retryCounter: c - 1
          });
      }
      return v({ type: "Failure", failure: await en.fromResponse(a) });
    }
    let l;
    try {
      l = tn(r)(await a.json());
    } catch (h) {
      const p = typeof t == "string" ? t : t.url;
      return v({ type: "DecodeError", route: p, error: h });
    }
    return l.status === "Failure" ? v({ type: "Failure", failure: l }) : Z(l);
  }
  rawFetch(t, n) {
    return fetch(t, n);
  }
}
function Xs(e, t) {
  let n = e.slice();
  for (const [r, o] of Object.entries(t))
    o !== void 0 && (n = n.replace(":" + r, t[r]));
  return n.includes(":") ? v(
    `Route mapping failed. Tried to map route '${e}' with params ${JSON.stringify(t)}`
  ) : Z(n);
}
function de(e, t) {
  if (!t) return e;
  const n = Xs(e, t);
  if (n.isErr())
    throw `Could not map route: '${e}' with params: ${JSON.stringify(t)}, failed with error: ${n.error}`;
  return n.value;
}
function Qs(e) {
  return e instanceof Mi ? e.issues.slice(0, 5).map((t) => `${t.path.join(".") || "(root)"}: ${t.message}`).join("; ") : String(e);
}
class Ue extends Error {
  constructor(n, r) {
    super(n, { cause: r.cause });
    N(this, "route");
    N(this, "method");
    this.name = "RouteDecodeError", this.route = r.route, this.method = r.method;
  }
  static fromDecodeFailure(n, r, o) {
    const i = `Could not decode ${o} response [${(/* @__PURE__ */ new Date()).toLocaleString("sv")}]: ${r} - ${Qs(n)}`;
    return new Ue(i, { route: r, method: o, cause: n });
  }
}
const iu = nn.GENERAL_OPTIMISTIC_LOCK;
class Me extends Error {
  constructor(n, r) {
    super(n, { cause: r.cause });
    N(this, "code");
    /** The backend's developer-facing text — English, with record ids in it. Not for the user. */
    N(this, "failureMessage");
    N(this, "route");
    N(this, "method");
    this.name = "RouteFailureError", this.code = r.code, this.failureMessage = r.failureMessage, this.route = r.route, this.method = r.method;
  }
  static fromHttpFailure(n, r, o) {
    const i = `Could not ${o} from route (${n.code}) [${(/* @__PURE__ */ new Date()).toLocaleString("sv")}]: ${r} - ${n.message}`;
    return new Me(i, {
      code: n.code,
      failureMessage: n.message,
      route: r,
      method: o,
      cause: n
    });
  }
}
class eu extends qs {
  constructor(n, r, o, i, s, u) {
    super(n);
    // Key: Authorization
    N(this, "authentication");
    N(this, "employer");
    this.apiUrl = n, this.getDecoder = r, this.putDecoder = o, this.postDecoder = i, this.deleteDecoder = s, this.prevent = u;
  }
  init(n) {
    this.employer = n;
  }
  setEmployer(n) {
    this.employer = n;
  }
  /**
   * This fetcher's credential in `Bearer {token}` format: the cached one, else
   * the stored token, else a renewal. `renew` discards the cached credential,
   * and the stored token when storage still holds that same credential.
   */
  async getAuthenticationHeader(n = !1) {
    if (!this.employer)
      return X(
        "UserTokenRetrieval",
        "!!! Error: Cannot get header if `this.employer` is undefined !!!"
      );
    const r = n ? this.authentication : void 0;
    let o = n ? void 0 : this.authentication;
    if (!o || Ie(o)) {
      const i = on();
      i && i !== r && (o = i);
    }
    if (!o || Ie(o))
      if (this.authTokenMutex)
        await this.authTokenMutex, o = this.authentication;
      else {
        this.authTokenMutex = new Promise((i) => {
          this.resolveAuthTokenMutex = i;
        });
        try {
          const i = await sn(this.employer.ssoProvider);
          if (i.isErr()) return i;
          o = i.value, this.setAuthenticationHeader(o);
        } finally {
          this.resolveAuthTokenMutex && this.resolveAuthTokenMutex(), this.authTokenMutex = void 0;
        }
      }
    return o ? (this.setAuthenticationHeader(o), Z(o)) : X("UserTokenRetrieval", "Could not retrieve token");
  }
  setAuthenticationHeader(n) {
    this.authentication = n;
  }
  async getHeaders(n, ...r) {
    return r.length > 1 ? X(
      "UserTokenRetrieval",
      "!!! Error: Cannot use getHeaders in fetcher with more than 1 argument !!!"
    ) : this.buildHeaders(n, !1);
  }
  /**
   * Headers carrying a freshly renewed credential, for retrying a request the
   * server rejected. The cached token is discarded rather than inspected: the
   * server is the authority on whether it is still good.
   */
  async renewHeaders(n, ...r) {
    return r.length > 1 ? X(
      "UserTokenRetrieval",
      "!!! Error: Cannot use renewHeaders in fetcher with more than 1 argument !!!"
    ) : this.buildHeaders(n, !0);
  }
  async buildHeaders(n, r) {
    const o = new Headers(n.headers), i = await this.getAuthenticationHeader(r);
    return i.isErr() ? v(i.error) : (o.set("Authorization", i.value), Z(o));
  }
  async fetch(n, r, o, i) {
    const s = `${this.apiUrl}${n}`, u = await this.getHeaders(r);
    return u.isErr() ? v(u.error) : (r.headers = u.value, this.api(s, r, o, (c) => this.renewHeaders(c), Yt(i)));
  }
  handleResult(n, r, o) {
    if (n.isErr())
      throw n.error.type === "Failure" ? Me.fromHttpFailure(n.error.failure, r, o) : n.error.type === "DecodeError" ? Ue.fromDecodeFailure(n.error.error, r, o) : `Authorization failure when trying to use ${o} [${r}]: ${JSON.stringify(
        n.error
      )}`;
    return n.value;
  }
  async getJson(n, r, o) {
    const i = {
      method: "GET",
      signal: o == null ? void 0 : o.signal,
      headers: {
        "Content-Type": "application/json"
      }
    }, s = de(n, r), u = this.getDecoder[n];
    return await this.fetch(s, i, u, o).then(
      (c) => this.handleResult(c, n, "GET").data
    );
  }
  async putJson(n, r, o, i) {
    var l;
    const s = {
      action: r,
      versions: ze(/* @__PURE__ */ new Map())
    }, u = {
      method: "PUT",
      body: JSON.stringify(s, Ee),
      headers: {
        "Content-Type": "application/json"
      }
    };
    if ((l = this.prevent) != null && l.put && this.prevent.put(n))
      return null;
    const c = de(n, o), a = this.putDecoder[n];
    return await this.fetch(c, u, a, i).then(
      (h) => this.handleResult(h, n, "PUT").data
    );
  }
  async postJson(n, r, o, i) {
    var l;
    const s = {
      action: r,
      versions: ze(/* @__PURE__ */ new Map())
    }, u = {
      method: "POST",
      body: JSON.stringify(s, Ee),
      headers: {
        "Content-Type": "application/json"
      }
    };
    if ((l = this.prevent) != null && l.post && this.prevent.post(n))
      return null;
    const c = de(n, o), a = this.postDecoder[n];
    return await this.fetch(c, u, a, i).then(
      (h) => this.handleResult(h, n, "POST").data
    );
  }
  async deleteJson(n, r, o, i) {
    var l;
    let s = {
      action: r,
      versions: ze(/* @__PURE__ */ new Map())
    };
    (!r || r === null) && (s = void 0);
    const u = {
      method: "DELETE",
      body: s !== void 0 ? JSON.stringify(s, Ee) : null,
      headers: {
        "Content-Type": "application/json"
      }
    };
    if ((l = this.prevent) != null && l.delete && this.prevent.delete(n))
      return null;
    const c = de(n, o), a = this.deleteDecoder[n];
    return await this.fetch(c, u, a, i).then(
      (h) => this.handleResult(h, n, "DELETE").data
    );
  }
}
class su extends eu {
  constructor(n, r, o, i, s, u, c, a) {
    super(n, o, i, s, u, c);
    N(this, "authKey");
    // Key: 'clientAuthKey'
    N(this, "clientAuthorization");
    /** Used to re-authorize for a client when needing to, cannot be undefined when using `clientAuthorization` */
    N(this, "authorizeScope");
    this.apiUrl = n, this.application = r, this.getDecoder = o, this.putDecoder = i, this.postDecoder = s, this.deleteDecoder = u, this.prevent = c, this.authorizePathResolver = a, this.authKey = `X-${r}-Authorization`;
  }
  /**
   * Try to use the local client authorization variable
   * - If there is no local variable or we have a token but it needs to be refreshed, try to renew the token (get a new one) for the current `authorizeScope`
   *
   * @returns A client authorization token in `Bearer ${token}` format
   */
  async getClientAuthorizationHeader(n = !1) {
    if (!this.authorizeScope)
      return X(
        "ClientTokenRetrieval",
        "!!! Error: Cannot use stored token in client fetcher if `this.authorizeScope` is undefined !!!"
      );
    let r = n ? void 0 : this.clientAuthorization;
    if (!r || Ie(r))
      if (this.clientTokenMutex)
        await this.clientTokenMutex, r = this.clientAuthorization;
      else {
        this.clientTokenMutex = new Promise((o) => {
          this.resolveClientTokenMutex = o;
        });
        try {
          const o = await this.authorizeForClient(this.authorizeScope);
          if (o.isErr()) return v(o.error);
          r = o.value.token, this.setClientAuthorizationHeader(r);
        } finally {
          this.resolveClientTokenMutex && this.resolveClientTokenMutex(), this.clientTokenMutex = void 0;
        }
      }
    return r ? (this.setClientAuthorizationHeader(r), Z(r)) : X("ClientTokenRetrieval", "Could not retrieve client token");
  }
  setClientAuthorizationHeader(n) {
    this.clientAuthorization = n;
  }
  setAuthorizeScope(n) {
    this.authorizeScope = n;
  }
  async getHeaders(n, r) {
    return this.buildClientHeaders(n, r, !1);
  }
  async renewHeaders(n, r) {
    return this.buildClientHeaders(n, r, !0);
  }
  async buildClientHeaders(n, r, o) {
    const i = new Headers(n.headers), s = await this.getAuthenticationHeader(o);
    if (s.isErr()) return v(s.error);
    if (i.set("Authorization", s.value), r.type === "Stored") {
      const u = await this.getClientAuthorizationHeader(o);
      if (u.isErr()) return v(u.error);
      i.set(this.authKey, u.value);
    } else
      i.set(this.authKey, r.token);
    return Z(i);
  }
  async getJsonHeaders(n) {
    const r = await this.getAuthenticationHeader();
    if (r.isErr()) return v(r.error);
    let o;
    return n.type === "Stored" ? o = await this.getClientAuthorizationHeader() : o = Z(n.token), o.isErr() ? v(o.error) : Z({ Authorization: r.value, Client: o.value });
  }
  async fetch(n, r, o, i) {
    const s = `${this.apiUrl}${n}`, u = i != null && i.clientToken ? { type: "Once", token: i.clientToken.token } : { type: "Stored" }, c = await this.getHeaders(r, u);
    return c.isErr() ? v(c.error) : (r.headers = c.value, this.api(
      s,
      r,
      o,
      (a) => this.renewHeaders(a, u),
      Yt(i)
    ));
  }
  /**
   * Sends an authorize request and returns the result with the retrieved token
   *
   * @param client The client we authorize for
   * @param kitFetch
   * @returns
   */
  async authorizeForClientInner(n, r) {
    var a;
    const o = {
      method: "POST",
      body: JSON.stringify(n)
    }, i = await this.getAuthenticationHeader();
    if (i.isErr()) return v(i.error);
    const s = new Headers({
      "Content-Type": "application/json",
      Authorization: i.value
    });
    o.headers = s;
    const u = ((a = this.authorizePathResolver) == null ? void 0 : a.call(this, "client", n.request.subject)) ?? "auth/authorize", c = await this.api(
      `${this.apiUrl}${u}`,
      o,
      (l) => L().parse(l),
      (l) => super.renewHeaders(l),
      { kitFetch: r }
    );
    return c.isErr() ? v(c.error) : Z({ application: this.application, token: `Bearer ${c.value.data}` });
  }
  /**
   * Authorizes for a client without saving the client authorization token to the storage.
   * Useful for when wanting to send a single request for a different `authorizeScope` that we currently are on
   * I.e. sending a request to an audit endpoint from analysis when previously have done `authorizeForClient` for that analysis client
   *
   * @param client The client we authorize for
   * @param kitFetch SvelteKit's fetch implementation
   * @returns An FetchResult that has the token fetched in the ok case
   */
  async authorizeForClientOnce(n, r) {
    const o = await this.authorizeForClientInner(
      { application: this.application, request: n },
      r
    );
    return o.isErr() ? v(o.error) : Z(o.value);
  }
  /**
   * Authorizes for a client and saves the token in the client auth storage.
   * It also sets the authorize request so that fetch requests in the future can renew their token
   * Use when needing a client auth token for a case.
   * I.e. when navigating to a case in audit
   *
   * @param client
   * @param kitFetch
   * @returns
   */
  async authorizeForClient(n, r) {
    const o = await this.authorizeForClientInner(
      { application: this.application, request: n },
      r
    );
    return o.isErr() ? v(o.error) : (this.setAuthorizeScope(n), this.setClientAuthorizationHeader(o.value.token), Z(o.value));
  }
  async authorizeForNats(n, r) {
    var a;
    const o = {
      method: "POST",
      body: JSON.stringify(n)
    }, i = await this.getAuthenticationHeader();
    if (i.isErr()) return v(i.error);
    const s = new Headers({
      "Content-Type": "application/json",
      Authorization: i.value
    });
    o.headers = s;
    const u = ((a = this.authorizePathResolver) == null ? void 0 : a.call(this, "nats")) ?? "auth/nats_token", c = await this.api(
      `${this.apiUrl}${u}`,
      o,
      un,
      (l) => super.renewHeaders(l),
      { kitFetch: r, retryCounter: 0 }
    );
    return c.isErr() ? v(c.error) : Z(c.value.data);
  }
  getClientAuthKey() {
    return this.authKey;
  }
  /** The client token as it stands, without authorizing or renewing to obtain one. */
  peekClientToken() {
    return this.clientAuthorization;
  }
}
function uu(e) {
  return typeof e == "object" && B(e) && "caseId" in e;
}
function cu(e) {
  return typeof e == "object" && B(e) && "corporateId" in e;
}
function au(e) {
  return typeof e == "object" && B(e) && "employerId" in e;
}
function lu(e) {
  return typeof e == "object" && B(e) && "accountId" in e;
}
function fu(e) {
  return typeof e == "object" && B(e) && "clientId" in e;
}
function hu(e) {
  return typeof e == "object" && B(e) && "DocumentId" in e;
}
const du = Kt("name", [
  O({ name: T("AuthorizationError") }),
  O({ name: T("TimeoutError") }),
  O({ name: T("InvalidSubjectError") }),
  O({ name: T("InvalidArgumentError") }),
  O({ name: T("InvalidOperationError") }),
  O({ name: T("UserAuthenticationExpiredError") }),
  O({ name: T("ClosedConnectionError") }),
  O({ name: T("DrainingConnectionError") }),
  O({ name: T("ConnectionError") }),
  O({ name: T("ProtocolError") }),
  O({ name: T("RequestError") }),
  O({ name: T("NoResponders") }),
  O({ name: T("PermissionViolationError") }),
  O({ name: T("Unknown") })
  // Internal error for when error type is not known
]);
export {
  qs as BaseFetcher,
  su as ClientFetcher,
  eu as Fetcher,
  iu as OPTIMISTIC_LOCK_CONFLICT_CODE,
  Ue as RouteDecodeError,
  Me as RouteFailureError,
  Bs as TOKEN_RENEWAL_LEAD_MS,
  Yt as apiOptions,
  lu as isParamsAccountId,
  uu as isParamsCaseId,
  fu as isParamsClientId,
  cu as isParamsCorporateId,
  hu as isParamsDocumentId,
  au as isParamsEmployerId,
  de as mapRouteParams,
  du as natsErrorMessageSchema,
  Gs as parseJwtTimestamps,
  Ee as replacer,
  Ie as shouldRenewToken
};
//# sourceMappingURL=df-fetcher.js.map
